import request from "@/utils/request";

/**
 * 查询我的站内信列表
 * @param {Object} params
 * @param {string} params.type - 类型(platform-平台,supplier-供应商,purchase-采购方)
 */
export function getMyMessageList(params) {
  return request({
    url: "/app/message/myMessageList",
    method: "get",
    params,
  });
}

/**
 * 查询我的站内信列表
 */
export function getMessageUnreadStat() {
  return request({
    url: "/app/message/messageUnreadStat",
    method: "get",
  });
}

/**
 * 设置消息已读
 * @param {string|number} messageId - 消息ID
 */
export function batchSetRead(messageId) {
  return request({
    url: `/app/message/batchSetRead/${messageId}`,
    method: "get",
  });
}
